import Bullets from './Bullets'

export default Bullets


// WEBPACK FOOTER //
// ./src/components/Slider/Bullets/index.js